import * as React from 'react';
import { debounce } from 'es-toolkit';

export const DEFAULT_DEBOUNCE_MS = 400;

export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = React.useState(value);

  const update = React.useMemo(() => debounce(setDebounced, delayMs), [delayMs]);

  React.useEffect(() => {
    update(value);
    return () => update.cancel();
  }, [value, update]);

  return debounced;
}
